module.exports = __webpack_public_path__ + "audio/oneAudio.3122c624.mp3";